import { State } from '@cemex/cmx-client-layout';
import { createFeatureSelector } from '@ngrx/store';
import * as fromCxExperiences from './cx-experience.reducer';

export const cxExperiencesKey = 'cxExperiences';
export const reducers = fromCxExperiences.reducer;

export interface CxExperiencesState extends State {
  [cxExperiencesKey]: fromCxExperiences.CxExperienceState;
}

export const selectExperiencesState = createFeatureSelector<fromCxExperiences.CxExperienceState>(cxExperiencesKey);
